import React, {Component} from "react";
import AddressWithSelection from "../../components/AddressWithSelection";
import "./AddressList.css";

class AddressList extends Component {

  constructor(props) {
    super(props);
    this.handleSelect = this.handleSelect.bind(this);
  }

  render() {
    let elements = this.props.addresses.map(x => {
      return (
        <AddressWithSelection
          key={x.get("addressId")}
          address={x.get("address")}
          id={x.get("addressId")}
          onSelect={this.handleSelect}
          selected={this.props.selectedId === x.get("addressId")}
          />
      )
    })
    return (
      <div className="AddressList">
        {elements}
      </div>
    )
  }

  handleSelect(id) {
    if (this.props.selectedId !== id) {
      this.props.onChange(id);
    }
  }

}

AddressList.defaultProps = {
  selectedId: ""
}

export default AddressList;